<template>
  <modal-astral v-if="modal.show" @close="clearForm">
    <template #header>
      Восстановление пароля
    </template>
    <template #headerSmall>
      <template v-if="emailSendingSuccess">
        <p>{{ successMessage }}</p>
      </template>
      <template v-else>
        <p>Для восстановления пароля Вам на электронный адрес будет выслано письмо с инструкцией.</p>
        <p>Введите адрес электронной почты, который Вы указывали при регистрации.</p>
      </template>
    </template>

    <!-- form -->
    <form v-if="!emailSendingSuccess" :class="[style.form, formBlocked ? style.formBlocked : '']" @submit.prevent="submitForm">
      <div :class="style.formGroupControls + ' ' + style.formGroupControlsHorizontal">
        <InputAstral v-model="form.email" placeholder="email" :error="$v.form.email.$error || form.errorMessage.length > 0" />
        <ButtonAstral type="submit">Восстановить</ButtonAstral>
      </div>
      <div v-if="$v.form.email.$dirty" :class="style.formGroupError">
        <template v-if="form.errorMessage">
          <span>{{ form.errorMessage }}</span>
        </template>
        <template v-else>
          <span v-if="!$v.form.email.required">Поле обязательное</span>
          <span v-if="!$v.form.email.email">Не валидный email</span>
        </template>
      </div>
    </form>
    <!-- form -->
  </modal-astral>
</template>

<script>
import style from '@/components/common/Astral/Styles/form.module.scss'

import ModalAstral from '@/components/common/Astral/Modal/Modal';
import InputAstral from '@/components/common/Astral/Input/Input';
import ButtonAstral from '@/components/common/Astral/Button/Button';

import { sendEmailForRecovery } from  '@/api/recovery';
import { formMixin } from '../mixin';
import { required, email } from 'vuelidate/lib/validators'

export default {
  name: 'PasswordRecoveryForm',
  components: {
    ModalAstral,
    InputAstral,
    ButtonAstral
  },
  mixins: [formMixin],
  data() {
    return {
      style: style,
      modal: {
        show: false
      },
      form: {
        email: '',
        errorMessage: ''
      },
      emailSendingSuccess: false,
      successMessage: ''
    }
  },
  mounted() {
    window.eventBus.$on('show-password-recover-modal', () => {
      this.modal.show = true;
    });
  },
  methods: {
    clearForm() {
      this.emailSendingSuccess = false;
      this.successMessage = '';
      this.form.errorMessage = '';

      this.modal.show = false
    },
    async submitForm() {

      this.$v.$touch();
      
      if (this.$v.$invalid) return false;

      this.blockUI();

      //request
      try {
        const data = await sendEmailForRecovery({email: this.form.email});

        this.unblockUI();

        if(!data.IsSuccess) {
          this.form.errorMessage = data.ErrorMessage;
        } else {
          this.successMessage = data.Message;
          this.emailSendingSuccess = true;
        }
      }
      catch(error) {
        this.unblockUI();
        this.form.errorMessage = error.message;
      }
    }
  },
  validations() {
    return {
      form: {			
        email: { required, email }
      }
    }
			
  },
}
</script>